module.exports = __webpack_public_path__ + "img/brodcast-exo.ebd1284b.jpg";